import NewsPageHeader from '@client/modules/ContentpageHeader/NewsPageHeader';
import SimpleFooter from '@client/modules/Footers/SimpleFooter';
import MagicModuleSwitcher from '@client/modules/MagicModuleSwitcher';
import Menu from '@client/modules/Menu/Menu';
import Functions from '@client/style/Functions';
import { Page } from '@client/style/Shared';
import { Breakpoints, presetColors } from '@client/style/Variables';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import BackgroundHazeSvg from '@client/assets/svgs/background-haze.svg';

const StyledPage = styled(Page)``;

const BackgroundHaze = styled.div<{ $fg?: string }>`
	position: fixed;
	top: 0px;
	left: 0px;
	width: 300vw;
	height: 300vh;
	z-index: 0;
	pointer-events: none;
	color: ${props => props.$fg};

	${Functions.breakpoint(Breakpoints.tablet)} {
		width: 100vw;
		height: 100vh;
	}
`;

export default function NewsPage(props: { content?: any }) {
	useEffect(() => {
		const elements: Element[] = Array.from(document.getElementsByClassName('colorWrapperAnimatedModule'));

		elements.forEach(element => {
			(element as HTMLElement).style.backgroundColor = presetColors.dust;
		});
	}, []);

	return (
		<StyledPage>
			<BackgroundHaze $fg={presetColors.blackish}>
				<BackgroundHazeSvg />
			</BackgroundHaze>
			<Menu specificColor={presetColors.blackish} />
			<NewsPageHeader
				author={props.content?.author}
				date={new Date(props.content?.createdAt)}
				image={props.content?.image}
				title={props.content?.title}
			></NewsPageHeader>
			<MagicModuleSwitcher modules={props.content ? props.content.modules : []} />
			<SimpleFooter optional={props.content.someFooter} />
		</StyledPage>
	);
}
